import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { Observable } from 'rxjs';
import {
  UserRegistrationApprovalDto,
  UserRegistrationCreateDto,
  UserRegistrationRejectionDto,
  UserRegistrationResponseDto,
} from '../../../core/data/new-dtos/user-registration.dtos';

@Injectable({ providedIn: 'root' })
export class UserRegistrationsService extends BaseCrudService<UserRegistrationResponseDto> {
  controller = 'UserRegistrations';

  // POST /api/UserRegistrations
  createRegistration(body: UserRegistrationCreateDto) {
    // API expects raw body (no { data: body }) according to project conventions for APIs using interceptor
    return this.create<UserRegistrationCreateDto, UserRegistrationResponseDto>(
      body,
      '',
      undefined,
      false,
    );
  }

  // POST /api/UserRegistrations/{id}/approve
  approve(
    id: number,
    body: UserRegistrationApprovalDto,
  ): Observable<UserRegistrationResponseDto> {
    return this.httpClient.post<UserRegistrationResponseDto>(
      `${this.controller}/${id}/approve`,
      body,
    );
  }

  // POST /api/UserRegistrations/{id}/reject
  reject(
    id: number,
    body: UserRegistrationRejectionDto,
  ): Observable<UserRegistrationResponseDto> {
    return this.httpClient.post<UserRegistrationResponseDto>(
      `${this.controller}/${id}/reject`,
      body,
    );
  }

  // GET /api/UserRegistrations/{id}
  getById(id: number): Observable<UserRegistrationResponseDto> {
    return this.httpClient.get<UserRegistrationResponseDto>(
      `${this.controller}/${id}`,
    );
  }

  // GET /api/UserRegistrations/me - the caller's own latest request
  getMine(): Observable<UserRegistrationResponseDto> {
    return this.httpClient.get<UserRegistrationResponseDto>(`${this.controller}/me`);
  }

  // GET /api/UserRegistrations/pending?role
  getPending(role?: string): Observable<UserRegistrationResponseDto[]> {
    const query = role ? `?${new URLSearchParams({ role }).toString()}` : '';
    return this.httpClient.get<UserRegistrationResponseDto[]>(
      `${this.controller}/pending${query}`,
    );
  }
}
